import React from "react";
import Listing from "./Posts/Listing";

const BlogPageDetail = () => {
  return (
    <div className="blog-page-container">
      <div className="blog-page-time">
        <span>DEVELOPMENT</span>
        <span>16 March 2023</span>
      </div>
      <div className="image-text-container">
        <span className="main-title">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod
        </span>
        <div className="blog-detail-image"></div>
        <div className="main-description-container">
          <span className="main-description">
            Lorem ipsum dolor sit amet consectetur adipiscing elit. Magnis dis
            parturient montes nascetur ridiculus mus donec. Arcu dignissim velit
            aliquam imperdiet mollis nullam volutpat. Tellus duis convallis
            tempus leo eu aenean sed. Purus est efficitur laoreet mauris
            pharetra vestibulum fusce. Praesent dui felis venenatis ultrices
            proin libero feugiat. Nisl malesuada lacinia integer nunc posuere ut
            hendrerit. At luctus nibh finibus facilisis dapibus etiam interdum.
            Cubilia curae hac habitasse platea dictumst lorem ipsum.
          </span>
          <span className="main-description">
            Himenaeos orci varius natoque penatibus et magnis dis. Euismod quam
            justo lectus commodo augue arcu dignissim. Placerat in id cursus mi
            pretium tellus duis. Maximus eget fermentum odio phasellus non purus
            est. Fames primis vulputate ornare sagittis vehicula praesent dui.
            Nec metus bibendum egestas iaculis massa nisl malesuada. Sodales
            consequat magna ante condimentum neque at luctus. Senectus netus
            suscipit auctor curabitur facilisi cubilia curae.
          </span>
          <div className="special-paragraph">
            <div className="left-para-border"></div>
            <span className="saying">
              “People worry that computers will get too smart and take over the
              world, but the real problem is that they’re too stupid and they’ve
              already taken over the world.”
            </span>
          </div>
          <span className="author-name">– Pedro Domingos</span>
          <span className="main-description">
            Odio phasellus non purus est efficitur laoreet mauris. Ornare
            sagittis vehicula praesent dui felis venenatis ultrices. Egestas
            iaculis massa nisl malesuada lacinia integer nunc. Ante condimentum
            neque at luctus nibh finibus facilisis. Auctor curabitur facilisi
            cubilia curae hac habitasse platea. Conubia nostra inceptos
            himenaeos orci varius natoque penatibus. Elementum a enim euismod
            quam justo lectus commodo. Vitae pellentesque sem placerat in id
            cursus mi. Molestie mattis scelerisque maximus eget fermentum odio
            phasellus. Cras eleifend turpis fames primis vulputate ornare
            sagittis.
          </span>
          <div className="blog-detail-image-2"></div>
          <div className="main-description-container">
            <span className="main-description">
              Risus blandit quis suspendisse aliquet nisi sodales consequat.
              Accumsan maecenas potenti ultricies habitant morbi senectus netus.
              Vel class aptent taciti sociosqu ad litora torquent. Ligula congue
              sollicitudin erat viverra ac tincidunt nam. Sit amet consectetur
              adipiscing elit quisque faucibus ex. Montes nascetur ridiculus mus
              donec rhoncus eros lobortis. Aliquam imperdiet mollis nullam
              volutpat porttitor ullamcorper rutrum.
            </span>
            <span className="main-description">
              Tempus leo eu aenean sed diam urna tempor. Laoreet mauris pharetra
              vestibulum fusce dictum risus blandit. Venenatis ultrices proin
              libero feugiat tristique accumsan maecenas. Integer nunc posuere
              ut hendrerit semper vel class. Finibus facilisis dapibus etiam
              interdum tortor ligula congue. Habitasse platea dictumst lorem
              ipsum dolor sit amet. Natoque penatibus et magnis dis parturient
              montes nascetur. Lectus commodo augue arcu dignissim velit aliquam
              imperdiet. Cursus mi pretium tellus duis convallis tempus leo.
            </span>
          </div>
        </div>
      </div>
      <div className="our-recent-posts-container">
        <span className="our-recent-posts">Our Recent Posts</span>
        <Listing></Listing>
      </div>
    </div>
  );
};

export default BlogPageDetail;
